// Red layout entrypoint
// Migrated from app/assets/javascripts/red.coffee

import 'libraries/jquery-global'
import 'jquery-ujs'
import 'popper.js'
import 'bootstrap'
import toastr from 'toastr'
window.toastr = toastr
import 'vendor/bootbox-4.3.0'
import 'vendor/bootstrap-validator'
// resizer + iframeResizer.contentWindow loaded as sync <script> in layout
import 'libraries/storage-access-api'
import 'libraries/locale'
import 'libraries/products-step'
import 'libraries/customer-information-step'
import 'libraries/idle'
import 'libraries/red-legacy'
import 'libraries/event-video-embed'

import { Application } from "@hotwired/stimulus"
import PostcodeLookupController from '../controllers/postcode_lookup_controller'
import ShopSeatplanV2Controller from '../controllers/shop_seatplan_v2_controller'
import SheetToggleController from '../controllers/sheet_toggle_controller'
const application = Application.start()
application.register("postcode-lookup", PostcodeLookupController)
application.register("shop-seatplan-v2", ShopSeatplanV2Controller)
application.register("sheet-toggle", SheetToggleController)
